import * as Sentry from '@sentry/browser';
import { RuntimeMode, SentryRelease } from './constants';

export enum SentryContext {
    field = 'field',
    global = 'global',
    template = 'template',
    license = 'license',
    browser = 'browser',
    nfeed = 'nfeed',
    auth = 'auth',
    adf = 'adf',
    mappers = 'mapper',
    request = 'request',
    xdomain = 'xdomain',
    attachment = 'attachment',
    legacy = 'legacy',
    evaluation = 'evaluation',
    yasoonAPI = 'yasoonAPI',
    yasoonBackend = 'yasoonBackend',
    elevatedPermission = 'elevatedPermission',
    jiraFeed = 'jiraFeed',
    unknownJiraError = 'unknownJiraError'
}

export function logSentryMessage(message: string, context?: SentryContext, additionalParams?: { [id: string]: any }): void {
    console.log('Sentry Message', message, additionalParams);

    Sentry.withScope(scope => {
        if (additionalParams) {
            Object.keys(additionalParams).forEach(key => {
                scope.setExtra(key, additionalParams[key]);
            });
        }

        if (context) {
            scope.setTag('context', context);
        }
        Sentry.captureMessage(message);
    });
    return;
}

export function logSentryError(error: any, context?: SentryContext, additionalParams?: { [id: string]: any }): void {

    let stringifiedErrorMessage = "";
    let stringifiedAdditionalParams = "";
    try {
        stringifiedErrorMessage = JSON.stringify(error);
    } catch (e) {
        //probably a circular error
    }
    try {
        stringifiedAdditionalParams = JSON.stringify(additionalParams);
    } catch (e) {
        //probably circular
    }

    console.log('Sentry Error', error, stringifiedErrorMessage, additionalParams, stringifiedAdditionalParams);

    Sentry.withScope(scope => {
        if (additionalParams) {
            Object.keys(additionalParams).forEach(key => {
                if (additionalParams[key] instanceof Error) {
                    scope.setExtra(key, additionalParams[key].toString());
                } else {
                    scope.setExtra(key, additionalParams[key]);
                }
            });
        }

        if (context) {
            scope.setTag('context', context);
        }

        Sentry.captureException(error);

    });

    return;
}

export function assert(condition: boolean, message: string): void | never {
    if (!condition)
        throw new Error(message);
}
export function initSentry() {
    //Sentry is completely local - no script is initalized yet
    Sentry.init({
        dsn: 'https://ddd7b48e8e61485aa72b831a5a130059@sentry.io/1331946',
        environment: RuntimeMode,
        release: SentryRelease,
        autoSessionTracking: true,
        // This enables included instrumentation (highly recommended), but is not
        // necessary for purely manual usage
        integrations: [],
        // As we want all errors in Sentry, send them all
        sampleRate: 1,
        // Percentage of transactions sent to Sentry
        // tracesSampleRate: RuntimeMode === "development" ? 1 : 0.01,
        ignoreErrors: [
            /800a025e/, //This error is thrown by the editor for selections... User will not notice
            /isSetSupported/, //This is an error thrown by Outlook itself for older Outlook versions...
        ],
        denyUrls: [
            /outlook-web-16.01.js/,
            /Office.js/,
            /oteljs_agave.js/,
        ],
    });
}

export async function flushSentry() {
    await Sentry.flush(300);
}
